export const LOCAL_STORAGE_AINO_PREVENT_POPUP_KEY =
  "wif_aino_prevent_chatPanel_Popup";
export const LOCAL_STORAGE_JOBS_SEARCH_HISTORY = "wif-jobs-search-history";
